import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { OrderPaymentFormEmbeddedPaymentMethod } from './embedded-payment-method';
const b = bemClassBuilder('v-order-payment-form-embedded-payment-methods');
export const OrderPaymentFormEmbeddedPaymentMethods = observer(props => {
    const { paymentMethods } = props;
    if (isEmptyArray(paymentMethods))
        return null;
    // TODO: This is a temporary fix to limit to one embedded payment. #208048
    const paymentMethodsToDisplay = [paymentMethods[0]];
    return (_jsx("div", Object.assign({ className: b.block() }, { children: paymentMethodsToDisplay.map(method => (_jsx(OrderPaymentFormEmbeddedPaymentMethod, { paymentMethodId: method.id }, method.id))) })));
});
OrderPaymentFormEmbeddedPaymentMethods.displayName = 'OrderPaymentFormEmbeddedPaymentMethods';
